import React, { Component } from "react";
import {
  Button,
  Table
} from "reactstrap";

import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import Pagination from "react-js-pagination";
import * as congNoAction from './actions'
import * as congNoConstant from './constants'
import DisplayRecordText from "../controls/_DisplayRecordText"
import { currentDate, abs2number } from "../../lib/common";
import ViewThanhToan from './_ViewThanhToan';
import * as common from '../../lib/common'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"

class CongNoKhachHangCt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tuNgay: currentDate().startOf("days"),
      denNgay: currentDate(),
      nvId: 0,
      khId: 0,
      item: {},
      list: [],
      total_record: 0,
      total: {},
      page: 1,
      per_page: 20,
      modalUpdateThanhToan: false,
      objThanhToan: {},
      tenKhachHang: ""
    };
  }
  viewThanhToan = (obj) => {
    obj["SoTienThanhToan"] = (obj.NoCuoiKy || 0 - obj.CoCuoiKy || 0)
    obj["NhanVienId"] = this.state.nvId
    obj["NgayThanhToan"] = currentDate()
    this.setState({ modalUpdateThanhToan: true, objThanhToan: obj })
  };
  viewThanhToanAll = (e) => {
    var tmp = new Object();
    tmp["KhachHangId"] = this.state.khId
    tmp["Id"] = null
    tmp["NhanVienId"] = this.state.nvId
    tmp["SoTienThanhToan"] = 0
    tmp["TenKhachHang"] = this.state.tenKhachHang
    tmp["NgayThanhToan"] = currentDate()
    this.setState({ modalUpdateThanhToan: true, objThanhToan: tmp })
  };
  handleCloseThanhToan = () => {
    this.setState({ modalUpdateThanhToan: false })
  };
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  search = () => {
    if (this.props.congNoKhCt.listRequesting) {
      return false;
    }
    return this.setState({ page: 1 }, () => {
      this.fetchList(1);
    });
  }
  fetchList(page) {
    const { congNoCtListRequest } = this.props
    var requestData = {
      nvId: this.state.nvId,
      khId: this.state.khId,
      fromDate: this.state.tuNgay.unix(),
      toDate: this.state.denNgay.endOf('days').unix(),
      page: page || this.state.page,
      per_page: this.state.per_page,
    }
    const onSuccess = ({ data }) => {
      const sumTotal = data.total_record ? data.total_record[0] : {}
      this.setState(
        {
          page: data.page,
          per_page: data.per_page,
          total_record: sumTotal.countRecord,
          total: sumTotal,
          list: data.records,
          tenKhachHang: data.records[0].TenKhachHang,
        }
      )
    }
    return congNoCtListRequest(requestData, onSuccess)
  }
  exportXls = () => {
    const { reportExportXlsRequest } = this.props
    var requestData = {
      nv: this.state.nvId,
      kh: this.state.khId,
      t: this.state.tuNgay.unix(),
      d: this.state.denNgay.endOf('days').unix(),
      loai: 1,
    };
    return reportExportXlsRequest(requestData, (item) => {
      var dataFile = new Blob([item], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExportCongNo';
      var fileName = "CongNoTheoDon.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExportCongNo";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
        link.remove();
      }
    });
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  ThanhToanCongNo = (obj) => {
    var requestData = {
      NhanVienId: obj.NhanVienId,
      KhachHangId: obj.KhachHangId,
      SoTienThanhToan: obj.SoTienThanhToan,
      congNoKhId: obj.Id,
      GhiChu: obj.GhiChu,
      NgayThanhToan: obj.NgayThanhToan.unix()
    };
    this.props.congNoNvUpdateRequest(requestData, () => {
      this.handleCloseThanhToan();
      this.search();
    })
  }

  checkKhachHangId = (callback) => {
    const { location } = this.props
    let nv = common.getParam(location, "nv"),
      kh = common.getParam(location, "kh"),
      t = common.getParam(location, "t"),
      d = common.getParam(location, "d"),
      prevUri = common.getParam(location, 'prev')
    this.setState({
      khId: kh,
      tuNgay: moment.unix(t),
      denNgay: moment.unix(d),
      nvId: nv,
      prevUri: prevUri
    }, callback)
  }
  initData = () => {
    this.fetchList(1);
  }
  componentDidMount() {
    this.checkKhachHangId(this.initData)
  }
  render() {
    const {
      list,
      tenKhachHang,
      tuNgay,
      denNgay
    } = this.state

    const {
      handleSubmit,
      congNoKhCt: {
        listRequesting,
        isRequesting,
        errors,
        messages
      },
    } = this.props
    const getUriDonHang = (item) => {
      return `${"/#/order-view/" + (item.LoaiKh || 0) + "/" + (item.ReferenceId || "")}`
    }
    const getUriPayHistory = (item) => {
      return `/#/lichsu-thanhtoan?loai=${congNoConstant.LOAI_CONG_NO.KHACH_HANG}&objectId=${item.KhachHangId}`
    }
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <div className="w-100 mb-2 mt-2">
              <Button size="md" color="success" className="mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Làm mới</Button>&nbsp;
              <Button size="md" color="primary" className="mr-1" onClick={this.exportXls.bind(this, {})}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
            </div>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100 mb-2 mt-4 text-center">
              <h4>Công nợ phải thu của {tenKhachHang} từ {moment(tuNgay).format("DD/MM/YYYY")} - {moment(denNgay).format("DD/MM/YYYY")}</h4>
            </div>
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="mb-0 d-sm-table table-sm table-bordered">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" rowSpan="2" className="text-center">Tên khách hàng</th>
                    <th scope="col" rowSpan="2" className="text-center">Số phiếu</th>
                    <th scope="col" colSpan="2" className="text-center">Đầu kỳ</th>
                    <th scope="col" colSpan="2" className="text-center">Phát sinh</th>
                    <th scope="col" colSpan="2" className="text-center">Cuối kỳ</th>
                    <th scope="col" rowSpan="2" width="80" className="text-center">Thanh Toán</th>
                    <th scope="col" rowSpan="2" width="80" className="text-center">Lịch sử</th>
                  </tr>
                  <tr>
                    <th className="text-center">Nợ</th>
                    <th className="text-center">Có</th>
                    <th className="text-center">Nợ</th>
                    <th className="text-center">Có</th>
                    <th className="text-center">Nợ</th>
                    <th className="text-center">Có</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-left">{res.TenKhachHang}</td>
                        <td className="text-center">
                          <a href={getUriDonHang(res)} target="_blank" className="text-primary font-weigh-bold">{res.ReferenceCode}</a>
                        </td>
                        <td className="text-right">{parseFloat(abs2number(res.NoDauKy || 0, res.CoDauKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(abs2number(res.CoDauKy || 0, res.NoDauKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(res.NoPhatSinh || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(res.CoPhatSinh || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(abs2number(res.NoCuoiKy || 0, res.CoCuoiKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-right">{parseFloat(abs2number(res.CoCuoiKy || 0, res.NoCuoiKy || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })} </td>
                        <td className="text-center">
                          {
                            (res.NoCuoiKy || 0) - (res.CoCuoiKy || 0) > 0 ?
                              <ButtonExt btnClass="mr-1 text-primary"
                                iconClass="fa-money"
                                displayText="TT"
                                btnType={BtnType.ButtonLink}
                                btnClick={() => this.viewThanhToan(res)}
                                permission={BtnPermissions.CongNoKhachHang.THANHTOAN} />
                              : ""
                          }
                        </td>
                        <td className="text-center">
                          <a href={getUriPayHistory(res)} target="_blank" className="text-success font-weigh-bold"><i className="fa fa-eye mr-1"></i>Xem</a>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="col" colSpan="2" className="text-right">
                      Tổng cộng
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(this.state.total.t_NoDauKy || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(this.state.total.t_CoDauKy || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(this.state.total.t_NoPhatSinh || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(this.state.total.t_CoPhatSinh || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(this.state.total.t_NoCuoiKy || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(this.state.total.t_CoCuoiKy || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" colSpan="2" className="text-left">
                      {
                        (this.state.total.t_NoCuoiKy || 0) - (this.state.total.t_CoCuoiKy || 0) > 0 ?
                          <ButtonExt btnClass="mr-1 text-primary"
                            iconClass="fa-money"
                            displayText="Thanh Toán tất cả"
                            btnType={BtnType.ButtonLink}
                            btnClick={() => this.viewThanhToanAll()}
                            permission={BtnPermissions.CongNoKhachHang.THANHTOAN} />
                          : ''
                      }
                      {/* <a href='#' className="text-primary font-weigh-bold" onClick={(e) => this.viewThanhToanAll(e)}><i className="fa fa-money mr-1"></i>Thanh Toán tất cả</a> */}
                    </th>
                  </tr>
                </tfoot>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.total_record}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
          <div>
            <div className="w-100 mb-2 mt-2">
              <a size="md" className="btn btn-secondary mr-1" href={this.state.prevUri}><i className="fa fa-arrow-left"></i> Danh sách</a>
            </div>
          </div>
          <ViewThanhToan item={this.state.objThanhToan}
            isRequesting={isRequesting}
            isOpen={this.state.modalUpdateThanhToan}
            onClose={this.handleCloseThanhToan}
            ThanhToanCongNo={this.ThanhToanCongNo}
            errors={errors}
            messages={messages}
          />
        </BlockUi>
      </div >
    )
  }
}

const mapStateToProps = state => ({
  congNoKhCt: state.congNoKhCt,
  client: state.client,
})

const connected = connect(mapStateToProps, {
  congNoCtListRequest: congNoAction.congNoCtListRequest,
  reportExportXlsRequest: congNoAction.reportExportXlsRequest,
  congNoNvUpdateRequest: congNoAction.congNoNvUpdateRequest
})(CongNoKhachHangCt)

const formed = reduxForm({
  form: 'congNoKhCt',
})(connected)

export default formed;




// WEBPACK FOOTER //
// ./src/views/CongNoKhachHang/CongNoKhachHangCt.js